import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetSpocDetailsRPC } from "./getSpocDetailsRPC";

export class GetSpocDetailsRPCClientImpl extends GetSpocDetailsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetSpocDetailsRPC.Request): Promise<LeoRPCResult<GetSpocDetailsRPC.Response, GetSpocDetailsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetSpocDetails",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetSpocDetailsRPC.ResponseDTO,
      GetSpocDetailsRPC.Errors.ErrorsDTO,
      GetSpocDetailsRPC.Response,
      GetSpocDetailsRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetSpocDetails",
      GetSpocDetailsRPC.Response.fromDTO,
      GetSpocDetailsRPC.Errors.fromDTO
    );
  }
}
